export default __webpack_public_path__ + "locales/hy-AM/ConvertPasswordDialog.json?hash=1c4cc7a4730d143e63856b95763dfa77";